/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2023
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { SkeletonText } from 'carbon-components-react';
const CodeViewerImpl = lazy(() => import('./CodeViewerImpl'));

export const CodeViewer = (props) => (
  <Suspense fallback={<SkeletonText paragraph={true} />}>
    <CodeViewerImpl {...props} />
  </Suspense>
);

CodeViewer.propTypes = {
  codeLanguage: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};
